


























































































































  import BaseVue from '@/mixins/BaseVue'
  import { Component, Prop, Watch, Mixins } from 'vue-property-decorator'
  import {
    UserInformations,
    SalesOrg,
    UserRole,
    UserPossible,
    UserSalesOrg,
    EUserRole
  } from '@/services/connecteur'
import { ModalType } from '@/models/Enum'
import serviceModule from '@/store/modules/ServiceModule'
import userModule from '@/store/modules/UserModule'
import SalesOrgsModule from '@/store/modules/SalesOrgsModule'

@Component
export default class UserDisplay extends Mixins(BaseVue) {
  @Prop() User!: UserInformations
  @Prop() modalMode!: ModalType

  public userUpdate: UserInformations = new UserInformations()
  public listSalesOrg: SalesOrg[] = []
  public lisrUserRoles: UserRole[] = []
  public selectedsalesorg: number[] = []
  public _timerId: any = 22
  public entries: any = []
  public isLoading = false
  public resAutoComplete: any = null
  public searchValue: any = null

  public mounted () {
    this.UserInputChanged()
    this.listSalesOrg = SalesOrgsModule.salesOrgsWithoutDisabled
    this.listSalesOrg.forEach((element: any) => {
      element.disabled =
        !this.isSuperAdmin &&
        !userModule.isUserAdminOnSalesOrg(element.id)
    })
    serviceModule.userRoleApi
      .getAllUserRoles()
      .then((response: UserRole[]) => {
        this.lisrUserRoles = response
      })
      .catch(err => {
        this.displayError(err)
      })
  }

  public getTitle () {
    switch (this.modalMode) {
      case ModalType.Delete: {
        return this.$t('user.delete').toString()
      }
      case ModalType.Add: {
        return this.$t('user.add').toString()
      }
      case ModalType.Update: {
        return this.$t('user.update').toString()
      }
      default: {
        return ''
      }
    }
  }

  public closeDialog () {
    this.searchValue = ''
    this.$emit('close:dialog', null)
  }

  public DeleteDialog () {
    return this.modalMode === ModalType.Delete
  }

  public ReactivateDialog () {
    return this.modalMode === ModalType.Reactivate
  }

  public UpdateDialog () {
    return this.modalMode === ModalType.Update
  }

  public AddDialog () {
    return this.modalMode === ModalType.Add
  }

  public ChangeUserEmail (isExtern: boolean) {
    if (isExtern) {
      const email = this.userUpdate.email?.split('@')
      if (email) {
        this.userUpdate.email = `${email[0]}.extern@${email[1]}`
      }
    } else {
      this.userUpdate.email = this.userUpdate.email?.replace('.extern', '')
    }
  }

  public DeleteUser () {
    this.cleanUser()
    serviceModule.userApi
      .deactivateUser(this.userUpdate)
      .then(() => {
        this.closeModalAndUpdate()
        this.displayMessage(this.$t('user.deleted').toString())
      })
      .catch(err => {
        this.displayError(err)
      })
  }

  public ReactivateUser () {
    this.cleanUser()
    serviceModule.userApi
      .activateUser(this.userUpdate)
      .then(() => {
        this.closeModalAndUpdate()
        this.displayMessage(this.$t('user.reactivated').toString())
      })
      .catch(err => {
        this.displayError(err)
      })
  }

  public AddUser () {
    this.cleanUser()

    serviceModule.userApi
      .postUser(this.userUpdate)
      .then(() => {
        this.closeModalAndUpdate()
        this.displayMessage(this.$t('user.added').toString())
      })
      .catch(err => {
        this.displayError(err)
      })
  }

  public async UpdateUser () {
    try {
      this.cleanUser()
      await serviceModule.userApi.putUser(this.userUpdate)
      this.closeModalAndUpdate()
      this.displayMessage(this.$t('user.updated').toString())
      if (this.itsMe) {
        localStorage.removeItem('token')
        this.$router.go(0)
      }
    } catch (err) {
      this.displayError(err)
    }
  }

  /**
   * Récupère et nettoie les propriétés du modèle avant d'enregistrer l'utilisateur.
   */
  public cleanUser (): void {
    this.userUpdate.userSalesOrg = []

    // Sélectionne toutes les sales orgs par défaut au SNP.
    if (this.isSupplyNetworkPlanner) {
      this.selectedsalesorg = this.listSalesOrg.map(s => s.id as number)
    }

    // Mappe les sales orgs sélectionnées.
    this.selectedsalesorg.forEach((val: number) => {
      if (this.userUpdate.userSalesOrg) {
        this.userUpdate.userSalesOrg.push(
          new UserSalesOrg({ salesOrgId: val })
        )
      }
    })

    // Set le key user s'il est caché
    if (this.isAdmin || this.isItLocal) {
      this.userUpdate.keyUser = true
    } else if (this.isReportingUser) {
      this.userUpdate.keyUser = false
    }
  }

  public get isExtern () {
    return this.userUpdate.email?.includes('.extern')
  }

  public get isAdmin () {
    return this.userUpdate.roleModelId === EUserRole.ADMINISTRATOR
  }

  public get isItLocal () {
    return this.userUpdate.roleModelId === EUserRole.IT_LOCAL
  }

  public get isSupplyNetworkPlanner () {
    return this.userUpdate.roleModelId === EUserRole.SUPPLY_NETWORK_PLANNER
  }

  public get isReportingUser () {
    return this.userUpdate.roleModelId === EUserRole.REPORTING
  }

  public get itsMe () {
    return this.userUpdate.id === userModule.id
  }

  public get isSuperAdmin () {
    return this.userUpdate.isSuperAdmin
  }

  public closeModalAndUpdate () {
    this.searchValue = ''
    this.$emit('update', null)
  }

  @Watch('searchValue')
  public search (val: string) {
    if (val == null) return
    if (val.length === 0) return
    // Iteams are loading
    // if (this.isLoading) return
    this.isLoading = true

    // Lazily load input items
    // cancel pending call
    serviceModule.userApi
      .getUser(val)
      .then(res => {
        this.entries = res
        this.entries.forEach((element: UserPossible) => {
          if (element.email) {
            element.email.replace('.extern', '')
          }
        })
      })
      .catch(err => {
        this.displayError(err)
      })
      .finally(() => {
        this.isLoading = false
      })
  }

  public items () {
    return this.entries.map((entry: any) => {
      const email = entry.email
      return Object.assign({}, entry, { email })
    })
  }

  @Watch('resAutoComplete')
  public updateUserUpdate () {
    this.userUpdate.firstName = this.resAutoComplete.firstName
    this.userUpdate.lastName = this.resAutoComplete.lastName
    this.userUpdate.email = this.resAutoComplete.email.replace('.extern', '')
  }

  @Watch('User')
  public UserInputChanged () {
      this.userUpdate = new UserInformations(this.User)
      this.selectedsalesorg = []

      if (this.userUpdate.userSalesOrg) {
        this.userUpdate.userSalesOrg.forEach((userSalesOrg: UserSalesOrg) => {
          if (userSalesOrg.salesOrg && userSalesOrg.salesOrg.id) {
            this.selectedsalesorg.push(userSalesOrg.salesOrg.id)
          }
        })
      }
    }
  }
